import React from "react";
import {IModalDialogHandler} from "../../services/dialog/dialog.service.interface";
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {Button} from "../../basic-ui-components/button/base/button.component";
import {SourceOfFundsBox} from "./boxes/source-of-funds.box";
import {CyClass} from "../../../common/cy-classes";
import {SourceOfFundsOpenChatBtnBox} from "./boxes/source-of-funds-open-chat-btn.box";

interface SourceOfFundsPopupComponentProps{
    messageRow1:string;
    messageRow2:string;
    openChatLabel:string;
    dialogHandler: IModalDialogHandler;
}

export class SourceOfFundsPopupComponent extends OrbitComponent<SourceOfFundsPopupComponentProps>{

    _closeDialog() {
        this.props.dialogHandler.close();
    }

    render(){
        let SourceOfFundsIcon = this.services.theme.currentTheme.icons.sourceOfFundsIcon;
        return (
            <SourceOfFundsBox>
                <SourceOfFundsIcon style={{color: this.services.theme.currentTheme.colors.popupIconColor}} size={10.7}/>
                <p>{this.props.messageRow1}</p>
                <p>{this.props.messageRow2}</p>
                <SourceOfFundsOpenChatBtnBox>
                    <Button className={CyClass('cy-source-of-funds-open-chat-btn')} preset="primary" fullWidth onClick={() => this._closeDialog()}>
                        { this.props.openChatLabel}
                    </Button>
                </SourceOfFundsOpenChatBtnBox>
            </SourceOfFundsBox>
        )
    }
}